import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { Space, Button } from "@masterteam/mt-design-react";

import Modal from "../../Modal";
import Info from "./Info";
import History from "./History";

import { ReactComponent as CloseIcon } from "../../../assets/images/close.svg";
import { ReactComponent as UserApproveIcon } from "../../../assets/images/user-approve.svg";

import { addToast } from "../../../helpers";
import api from "../../../providers/api";
import { REQUEST_STATUSES } from "../../../configs/enums";

import "./style.scss";

function ApproveRejectModal({
  isOpen,
  onCloseModal,
  data = {},
  type,
  refetchData
}) {
  const [selectedTab, setSelectedTab] = useState("info");
  const [loading, setLoading] = useState(false);
  const [notes, setNotes] = useState("");
  const [attachments, setAttachments] = useState([]);

  const themeColor = useSelector((store) => store.theme.primary);

  async function onAction(isApprove = false) {
    try {
      setLoading(true);
      const body = {
        RequestID: data.RequestID || data.ID,
        Action: isApprove
          ? REQUEST_STATUSES?.APPROVED
          : REQUEST_STATUSES?.REJECTED,
        Comments: notes || ""
      };

      if (attachments?.length) {
        const attachmentsRes = await api.attachment.create(attachments);
        body.Attachments = attachmentsRes?.Data?.map((e) => ({ ID: e }));
      }

      await api.workflow.doAction(body);

      onCloseModal();
      if (refetchData) refetchData();
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
      <Space className="approve-reject-modal" direction="vertical">
        <Space
          className="approve-reject-modal__header"
          align="center"
          onClick={onCloseModal}
        >
          <Space align="center">
            <UserApproveIcon height={28} width={28} />
            <FormattedMessage id="common.approve-or-reject" />
          </Space>
          <Space className="approve-reject-modal__header__close">
            <CloseIcon height={16} width={16} />
          </Space>
        </Space>
        <Space className="approve-reject-modal__tabs">
          <Space
            className="approve-reject-modal__tabs__tab"
            onClick={() => setSelectedTab("info")}
          >
            <FormattedMessage id="kpi-details.details" />
            {selectedTab === "info" ? (
              <div
                className="approve-reject-modal__tabs__tab__bar"
                style={{ backgroundColor: themeColor }}
              />
            ) : null}
          </Space>
          <Space
            className="approve-reject-modal__tabs__tab"
            onClick={() => setSelectedTab("history")}
          >
            <FormattedMessage id="kpi-details.history" />
            {selectedTab === "history" ? (
              <div
                className="approve-reject-modal__tabs__tab__bar"
                style={{ backgroundColor: themeColor }}
              />
            ) : null}
          </Space>
        </Space>
        <Space className="approve-reject-modal__content">
          {selectedTab === "info" ? (
            <Info
              data={data}
              type={type}
              notes={notes}
              setNotes={setNotes}
              attachments={attachments}
              setAttachments={setAttachments}
            />
          ) : null}
          {selectedTab === "history" ? <History data={data} /> : null}
        </Space>
        <Space className="approve-reject-modal__footer">
          <Button
            backgroundColor="#D4D6DD"
            color="#545759"
            onClick={onCloseModal}
          >
            <FormattedMessage id="common.cancel" />
          </Button>
          <Button
            variant="success"
            onClick={() => onAction(true)}
            // loading={loading}
            disabled={loading}
          >
            <FormattedMessage id={"common.approve"} />
          </Button>

          <Button
            variant="error"
            onClick={() => onAction(false)}
            // loading={loading}
            disabled={loading || !notes?.trim()?.length}
          >
            <FormattedMessage id={"common.reject"} />
          </Button>
        </Space>
      </Space>
    </Modal>
  );
}

export default ApproveRejectModal;
